import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import LanguageContainer from "./LanguageContainer";

ReactDOM.render(<LanguageContainer/>, document.getElementById('root'));
serviceWorker.unregister();
